<template>
  <div  :class="'glowBtn '+getState" :style="mystyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    state:null,
    item: null,
    width: {
      type: String,
      default: "200"
    }
  },
  data() {
    return {};
  },
  computed: {
    mystyle() {
      return "width:" + this.width + "px;";
    },
    getState(){
      return this.state
    }
     
  },
  methods: {
    itemClick(item) {
      console.log(item);
      if (item) {
        item.state = !item.state;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
 @import "@/assets/sass/variables.scss";
//$border-blue:#00bbff;
.glowBtn {
  width: 200px;
  border: solid 3px $glow-colour;
  background-color: $glow-bg;
  box-shadow: inset 0px 0px 20px 0px;
  font-family: "Orbitron";
  font-size: 18px;
  color: $glow-colour;
  padding: 5px;
  margin: 5px;
  line-height: 24px;
  cursor: pointer;
  text-transform: uppercase;
}
.glowBtn.true {
  border: solid 3px $glow-text-colour-selected;
  background-color: $glow-text-colour-selected;
  box-shadow: inset 0px 0px 20px -5px;
  color: #03b;
}
.glowBtn.hover {
  border: solid 3px $glow-text-colour-selected;
  color: $glow-text-colour-selected;
}
</style>
